import React, { use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DashboardState } from "../hooks/useDashboardState";

export type DashboardContextType = DashboardState;

export const DashboardContext = React.createContext<DashboardContextType | undefined>(undefined);

export const useDashboardContext = () => {
  const context = use(DashboardContext);
  return defined(context);
};
